let DeviceUtil = require("../util/DeviceUtil");

let SubjectConfig = function (props) {
  let { study, devices } = props;
 
  if (!study.deviceConfigs || !devices) {
    return "...";
  }

  if (!devices.length) {
    return "N/A";
  }

  return (
    <table className="rc-subject-configs">
      <tbody>
        {study.deviceConfigs.filter(function (dc) {
          return dc.mode === "UNSUPERVISED";
        }).map(function (dc) {
          let match = devices.find(function (device) {
            return device.deviceConfigId === dc.id;
          });

          return (
            <tr key={dc.id}>
              <td>{tx(dc.physicalConfig.location)}</td>
              <td>{match ? tx("side." + match.physicalConfigs[0].value.side) : "N/A"}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

module.exports = SubjectConfig;
